<template>
  <div class="component tip" :style="tipStyle">
    <i v-if="defaultConfig.hasIcon" :class="defaultConfig.icon"></i>
    <span>{{ title }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: '测试文案'
    }
  },
  data () {
    return {
      defaultConfig: {
        color: '#C0C4CC',
        size: 12,
        hasIcon: false,
        icon: 'el-icon-warning-outline'
      },
      tipStyle: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.init()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    init () {
      Object.assign(this.defaultConfig, this.config)
      this.tipStyle = `color: ${this.defaultConfig.color};font-size: ${this.defaultConfig.size}px;`
    }
  }
}
</script>

<style lang='scss' scoped>
.component.tip {
  i { margin-right: 6px; }
}
</style>
